import './update-password.css'
import * as React from 'react'
import PasswordForm from '../../components/password-form/password-form'

/**
 * Update Password Component.
 * Represents the update password page.
 *
 * @returns {React.ReactElement} - Update Password Component.
 */
const UpdatePassword = () => {
  return <PasswordForm />
}

export default UpdatePassword
